import BlackList from './List.vue'
import AppContainer from '@/container/AppContainer.vue';
import BlackListUpload from './Upload.vue'

export const routes = [
    {
        path: '/blacklists',
        name: 'blacklists',
        component: AppContainer,
        children: [
          {
              path: 'upload',
              component: BlackListUpload,
              meta: {
                  title: "Upload Blacklist"
              }
          },
            {
                path: '/',
                component: BlackList,
                meta: {
                    title: "Blacklists"
                }
            }
        ]
    }
]
